import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { TokenStorageService } from '../_services/token-storage.service';
import {MessageService} from 'primeng/api';
import {catchError, map, retry} from 'rxjs/operators';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {throwError} from 'rxjs';
import {Result} from '../_services/tsa.service';
import {Globals} from '../globals';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  @ViewChild("username") username: any;
  @ViewChild("password") password: any;
  form: any = {
    username: null,
    password: null
  };
  isLoggedIn = false;
  isLoginFailed = false;
  isBusy = false;
  errorMessage = '';
  roles: string[] = [];

  constructor(private authService: AuthService, private tokenStorage: TokenStorageService,
              private messageService: MessageService, private http: HttpClient, private globals: Globals) { }

  ngOnInit(): void {
    if (this.tokenStorage.getToken()) {
      this.isLoggedIn = true;
      this.roles = this.tokenStorage.getUser().roles;
    }
  }

  onSubmit(): void {
    const { username, password } = this.form;
    this.isBusy = true;
    this.authService.login(username, password).subscribe(
      data => {
        this.isBusy = false;
        this.tokenStorage.saveToken(data.accessToken);
        this.tokenStorage.saveUser(data);
        this.roles = this.tokenStorage.getUser().roles;
        if(this.roles.includes('ROLE_TSA_USER')||this.roles.includes('ROLE_TSA_ADMIN')) {
            this.isLoginFailed = false;
            this.isLoggedIn = true;
            this.reloadPage();
        } else {
          this.errorMessage = "Sorry, this username is not authorized for this product.";
          this.isLoginFailed = true;
          this.username.valueAccessor._elementRef.nativeElement.focus();
        }

      },
      err => {
        this.isBusy = false;
        if(err.error.message) {
          if (err.error.message == "Bad credentials")
            this.errorMessage = "The username or password is incorrect! Please try again.";
          else
            this.errorMessage = err.error.message;
        }
        else if (err.error) this.errorMessage = err.error;
        this.isLoginFailed = true;
        this.password.valueAccessor._elementRef.nativeElement.focus();
      }
    );
  }

  reloadPage(): void {
    window.location.replace("/");
  }

  showConfirm() {
    this.messageService.clear();
    this.messageService.add({key: 'c', sticky: true, severity:'warn'});
  }

  resetPassword(): void {
    if(this.form.username == null || this.form.username.trim() == "") {
      this.messageService.add({key: 'bc', severity:'warn', summary: 'Message', life: 5000,
        detail: 'Please input your user name first.'});
      if (this.username != undefined)
        this.username.valueAccessor._elementRef.nativeElement.focus();
    } else {
      this.isBusy = true;
      this.http.get<any>(this.globals.url_root + "/auth/ResetPassword.action?user=" + this.form.username)
        .subscribe(
          (result: any) => {
            this.isBusy  = false;
            let msgType = 'success';
            if (!result.success) msgType = 'error';
            this.messageService.add({key: 'bc', severity:msgType, summary: 'Message', life: 5000,
              detail: result.message});
          },
        err => {
          this.isBusy = false;
          if(err.error.message) {
            this.errorMessage = err.error.message;
          }
          else if (err.error) this.errorMessage = err.error;
          this.messageService.add({key: 'bc', severity:'error', summary: 'Message', life: 5000,
            detail: this.errorMessage});
        }
      );
    }
  }

  onClose(): void {
    window.location.replace("/#tsa");
  }

  onConfirm() {
   this.messageService.clear('c');
   this.resetPassword();
  }

  onReject() {
    this.messageService.clear('c');
  }
}
